import React, { Dispatch, SetStateAction } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

type Props = {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
};
const TextEditor: React.FC<Props> = ({ value, setValue }) => {
  return <ReactQuill theme="snow" value={value} onChange={setValue} />;
};

export default TextEditor;
